/* eslint-disable react/no-array-index-key */
import styled from 'styled-components';

type PositionProps = {
  position: {
    positionName: string;
    offer: {
      title: string;
      sectionList: string[];
    };
    requirementsMust: {
      title: string;
      sectionList: string[];
    };
    requirementsNiceToHave?: {
      title: string;
      sectionList: string[];
    };
  };
};

const BoardContainer = styled.div`
  max-width: 160rem;
  margin: 0 auto;
  font-size: 1.6rem;
  padding: 1.6rem 2.4rem;
  font-family: ${({ theme }) => theme.FONTS.SECONDARY};

  @media ${({ theme }) => theme.DEVICE.LG} {
    font-size: 2.4rem;
    margin-bottom: 2.4rem;
  }
`;

const PositionName = styled.h2`
  display: flex;
  font-size: 2.8rem;
  line-height: 1.5;
  align-items: left;
  margin: 2.4rem 0;
  width: 100%;
  color: ${({ theme }) => theme.COLORS.SECONDARY};

  @media ${({ theme }) => theme.DEVICE.LG} {
    line-height: 2;
    margin: 3.2rem 0;
    font-size: 4.8rem;
    justify-content: center;
  }
`;

const StyledList = styled.ul`
  display: block;
  list-style-type: disc;
  max-width: 65rem;
  margin-bottom: 1em;
  margin-left: 2.6rem;
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 2;
  list-style-image: url('/img/jobsPage/check-icon.png');
  filter: brightness(0) saturate(100%) invert(2%) sepia(25%) saturate(8%) hue-rotate(314deg) brightness(102%)
    contrast(81%);

  li {
    padding: 0.2rem 0.4rem;
  }

  @media ${({ theme }) => theme.DEVICE.LG} {
    line-height: 1.8;
    padding-inline-start: 3.2rem;
    margin-block-start: 0;
    margin-block-end: 0;
    font-size: 1.8rem;
    width: 52%;
  }
`;

const ListSection = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 2.4rem;

  &:before {
    content: '';
    position: absolute;
    font-size: 12rem;
    opacity: 0.035;
    background: url('/img/jobsPage/bg-3.png');
    background-position: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  h3 {
    font-size: 2.2rem;
    margin-bottom: 1.6rem;
  }

  @media ${({ theme }) => theme.DEVICE.LG} {
    flex-direction: row;
    padding: 1.2rem 0;

    h3 {
      font-size: 3.2rem;
      width: 44%;
      padding-right: 4%;
      text-align: right;
    }
  }
`;

function JobBoard({ position }: PositionProps): JSX.Element {
  return (
    <BoardContainer>
      <PositionName>{position.positionName}</PositionName>
      <ListSection>
        <h3>{position.offer.title}</h3>
        <StyledList>
          {position.offer.sectionList.map((item, index) => (
            <li key={index.toString()}>{item}</li>
          ))}
        </StyledList>
      </ListSection>
      <ListSection>
        <h3>{position.requirementsMust.title}</h3>
        <StyledList>
          {position.requirementsMust.sectionList.map((item, index) => (
            <li key={index.toString()}>{item}</li>
          ))}
        </StyledList>
      </ListSection>
      {position.requirementsNiceToHave ? (
        <ListSection>
          <h3>{position.requirementsNiceToHave.title}</h3>
          <StyledList>
            {position.requirementsNiceToHave.sectionList.map((item, index) => (
              <li key={index.toString()}>{item}</li>
            ))}
          </StyledList>
        </ListSection>
      ) : null}
    </BoardContainer>
  );
}

export default JobBoard;
